
export const Loading = () => {
  return (
    <div className="loading-map d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h3>
          Geolocalização
        </h3>
        <span>
          Carregando...
        </span>
      </div>
    </div>
  )
}
